import { Delete, Edit } from '@mui/icons-material'
import { Box, Card, CardContent, CardHeader, IconButton } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import React, { useEffect, useState } from 'react'
import TambahPendapatan from './TambahPendapatan'
import userStore from 'store/userStore'
import { CustomDescrypt } from 'global/func'
import { decodeToken } from 'react-jwt'
import { MaterialReactTable } from 'material-react-table'
import { postDataWithResponse } from 'global/postFunc'
import Swal from 'sweetalert2'
import { postDelete } from 'global/postFunc'

const Pendapatan = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [updating, setUpdating] = useState(false)
    const [loading, setLoading] = useState(false)

    const [listPendapatan, setListPendapatan] = useState([])

    const [opd, setOpd] = useState({})
    useEffect(() => {
        console.log(decodedUser);
        setOpd({
            kd_pd: decodedUser.kd_pd,
            nm_pd: decodedUser.nm_pd
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqPendapatan = () => {
        addReq()
        postDataWithResponse(
            '/admin-opd/get-tr-pendapatan',
            {
                kd_pd: opd.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setListPendapatan(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqPendapatan()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updating])

    const deletePendapatan = (id, nama) => {
        Swal.fire({
            title: `Hapus Data?`,
            text: `${nama} akan Dihapus`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/admin-opd/tr-pendapatan/delete',
                    {
                        _method: 'DELETE',
                        id: id
                    },
                    decryptedUser,
                    setLoading,
                    () => { setUpdating(!updating) }
                )
            }
        })
    }

    const columns = [
        {
            accessorKey: 'kode',
            header: 'Rekening',
            Cell: ({ cell }) => (
                <Box>
                    <ArgonTypography
                        fontWeight='bold'
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                </Box>
            )
        },
        {
            accessorKey: 'uraian',
            header: 'Uraian',
            Cell: ({ cell }) => (
                <ArgonTypography
                    // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                    variant="inherit"
                    fontSize="small"
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'anggaran',
            header: 'Anggaran',
            Cell: ({ cell }) => (
                <ArgonTypography
                    // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                    variant="inherit"
                    fontSize="small"
                    color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                >
                    {
                        parseInt(cell.getValue()) === 0 ? ' ' : parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        },
    ];

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Rincian Belanja</ArgonTypography>
                        }
                        action={
                            <TambahPendapatan
                                decryptedUser={decryptedUser}
                                opd={opd}
                                updating={updating}
                                setUpdating={setUpdating}
                                addReq={addReq}
                                tahunAnggaran={tahunAnggaran}
                                disabled={opd?.kd_pd === undefined}
                            />
                        }
                    />
                    <CardContent>
                        <MaterialReactTable
                            columns={columns}
                            data={listPendapatan}
                            // enableExpanding
                            // enableExpandAll
                            muiTableHeadCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTableFooterCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTopToolbarProps={{
                                sx: { fontSize: '0.875rem' }
                            }}
                            initialState={{
                                expanded: true
                            }}
                            enablePagination={false}
                            enableColumnFilters={false}
                            enableSorting={false}
                            state={{ isLoading: loading }}
                            enableRowActions={true}
                            positionActionsColumn='first'
                            renderRowActions={({ row, table }) => (
                                <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                                    <IconButton
                                        color="secondary"
                                    // onClick={() => {
                                    //     setEditData(row.original)
                                    //     handleOpenEdit()
                                    // }}
                                    >
                                        <Edit fontSize='small' color='primary' />
                                    </IconButton>
                                    <IconButton
                                        color="error"
                                        onClick={() => {
                                            deletePendapatan(row.original.id, row.original.uraian)
                                        }}
                                    >
                                        <Delete fontSize='small' color='error' />
                                    </IconButton>
                                </Box>
                            )}
                            displayColumnDefOptions={{
                                'mrt-row-actions': {
                                    header: 'Action', //change header text
                                    size: 5, //make actions column wider
                                    alignment: 'left'
                                },
                                'mrt-row-expand': {
                                    header: 'Expand', //change header text
                                    size: 5, //make actions column wider
                                    alignment: 'left'
                                },
                            }}
                        />
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default Pendapatan